<template>
  <main class="vendor-page">
    <VendorStartScreen
      v-if="landing?.startScreenBlock"
      :vendor="landing?.startScreenBlock"
      class="vendor-page__block ui-container"
    />

    <MainCardsBlock
      v-if="landing?.coursesBlock && courses?.length"
      :title="landing?.coursesBlock.title"
      :cards="courses || []"
      :button-link="vendorCoursesLink"
      button-text="Смотреть все курсы"
      shadow
      class="vendor-page__block vendor-page__block--shadow"
    />

    <VendorSpeakers
      v-if="landing?.speakersBlock"
      :title="landing?.speakersBlock?.title"
      :speakers="landing?.speakersBlock.speakers"
      class="vendor-page__block"
    />

    <VendorReviews
      v-if="reviews && rating"
      :reviews="reviews"
      :rating="rating?.rating"
      class="vendor-page__block"
    />

    <VendorAbout
      v-if="landing?.aboutBlock"
      :title="landing?.aboutBlock.title"
      :data="landing?.aboutBlock.data"
      class="vendor-page__block"
    />

    <VendorAchievements
      v-if="landing?.achievementsBlock"
      :title="landing?.achievementsBlock.title"
      :achievements="landing?.achievementsBlock.achievements"
      class="vendor-page__block"
    />

    <VendorFaq
      v-if="landing?.faqBlock"
      :title="landing?.faqBlock.title"
      :faq="landing?.faqBlock.faq"
      class="vendor-page__block"
    />
  </main>
</template>

<script setup lang="ts">
  import { storeToRefs } from 'pinia'
  import VendorStartScreen from '@/components/Vendor/VendorStartScreen.vue'
  import VendorSpeakers from '@/components/Vendor/VendorSpeakers.vue'
  import VendorFaq from '@/components/Vendor/VendorFaq.vue'
  import VendorReviews from '@/components/Vendor/VendorReviews.vue'
  import VendorAbout from '@/components/Vendor/VendorAbout.vue'
  import VendorAchievements from '@/components/Vendor/VendorAchievements.vue'

  import { usePartnersStore } from '@/store/partners'
  import { useCoursesStore } from '@/store/courses'

  const partnersStore = usePartnersStore()
  const { landing, reviews, rating } = storeToRefs(partnersStore)
  const coursesStore = useCoursesStore()
  const { courses } = storeToRefs(coursesStore)
  const route = useRoute()

  const vendorCoursesLink = computed(() => {
    return `/catalog/?companies=${route.params.vendor}`
  })

  await useAsyncData(
    'getLanding',
    () => partnersStore.getLanding(route.params.vendor as string)
  )

  await useAsyncData(
    'getReviews',
    () => partnersStore.getReviews({
      limit: 12,
      companyId: landing.value?.rawData.common.id,
      entityType: 'academica_landings',
    })
  )

  await useAsyncData(
    'getRating',
    () => partnersStore.getRating(landing.value?.rawData.common.id)
  )

  if (landing.value?.coursesBlock) {
    await useAsyncData(
      'getCourses',
      () => coursesStore.getCourses({ companies: [route.params.vendor as string], limit: 4 })
    )
  }

  useHead({
    title: `${landing.value?.commonBlock?.abbreviation} | Академика`,
  })
</script>

<style lang="scss">
  @use '@academica-box/utils/styles/mixins/UiMedia' as *;
  @use '@academica-box/utils/styles/mixins/UiZIndex' as *;

  .vendor-page {
    padding-bottom: 56px;
    overflow-x: hidden;

    @include media(lg) {
      padding-bottom: 96px;
    }
  }

  .vendor-page__block {
    &:not(:last-child) {
      margin-bottom: 56px;

      @include media(lg) {
        margin-bottom: 96px;
      }
    }

    &--shadow {
      position: relative;

      &::before {
        @include z-index(below);

        position: absolute;
        top: 45%;
        z-index: -1;
        width: 100%;
        height: 50%;
        border-radius: 30%;
        background-color: var(--bg-invert-color);
        opacity: 0.02;
        filter: blur(25px);
        content: "";
      }
    }
  }
</style>
